import type { components } from "@/api-schema";
import { mapAttributeValueToName } from "@/common/helpers/map-attribute-value-to-name";
import { useMemo } from "react";

type AppRole = components["schemas"]["AppRole"];
type AppRoleAttribute = components["schemas"]["AppRoleAttribute"];

export function useFilteredRoles(roles: AppRole[], attributes: AppRoleAttribute[], searchTerm: string) {
  return useMemo(() => {
    const filteredRoles = roles.filter((role) =>
      `${role.name} ${role.v1Id || ""}`.toLowerCase().includes(searchTerm.toLowerCase()),
    );

    const filteredAttributes = attributes.filter((attribute) =>
      (mapAttributeValueToName(attribute.type) || attribute.type || "")
        .toLowerCase()
        .includes(searchTerm.toLowerCase()),
    );

    return {
      filteredRoles,
      filteredAttributes,
      totalFiltered: filteredRoles.length + filteredAttributes.length,
    };
  }, [roles, attributes, searchTerm]);
}
